import { useFreshSetting } from "./useFreshSetting";

export const OPERATIONAL_WRITES_SETTING = "Mill.OperationalWritesEnabled";

export const OPERATIONAL_WRITES_LOCKED_MESSAGE =
	"This action is disabled until this system becomes the official one.";

// Pre-cutover lock (#782). Write actions on operational screens stay disabled
// unless the setting is exactly '1'; a missing row or any other value keeps
// them locked. The full list of gated screens and actions lives in the #782
// docs. Remove this hook and its call sites once the new system is official.
export const useOperationalWritesLocked = (): boolean =>
	useFreshSetting(OPERATIONAL_WRITES_SETTING) !== "1";
